import { useTranslation } from "react-i18next";
import LoadingCard from "./LoadingCard";
import formatBytes from "utils/formatBytes";
import StatsCard from "./StatsCard";

import { StorageStatRecord } from "@dashboard-v3/api";

interface Props {
  loading: boolean;
  currentStats: StorageStatRecord[];
  previousStats: StorageStatRecord[];
}

export default function StorageUploadsCard(props: Props) {
  const { loading, currentStats, previousStats } = props;
  const { t } = useTranslation("usageReports");

  if (loading) return <LoadingCard />;

  const previous = previousStats.reduce(toStorageTotals, 0);
  const current = currentStats.reduce(toStorageTotals, 0);

  return (
    <StatsCard
      label={t("uploadedAmount")}
      value={formatBytes(current)}
      previousAmount={previous}
      currentAmount={current}
    />
  );
}

function toStorageTotals(acc: number, storage: StorageStatRecord) {
  return (
    acc +
    storage.totalBytesATTACHMENT +
    storage.totalBytesEMAIL +
    storage.totalBytesPDF +
    storage.totalBytesZIP
  );
}
